import React, { useState } from 'react';
import { EntregadorRelatorio, FormData } from './types';
import { api, API_ROUTERS } from '../../../services/api';
import RelatoriosEntregadoresContent from './view';

const RelatoriosEntregadoresContainer: React.FC = () => {
  const [relatorioEntregador, setRelatorioEntregador] = useState<EntregadorRelatorio[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [formData, setFormData] = useState<FormData>({
    data: ''
  });

  const handleInputChange = (field: keyof FormData, value: string) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSearch = async () => {
    if (!formData.data) {
      setError('Por favor, selecione uma data');
      return;
    }

    setLoading(true);
    setError('');
    setRelatorioEntregador([]);

    try {
      const url = `${API_ROUTERS.RELATORIOS_ENTREGADORES}?data=${formData.data}`;

      const response = await api.get(url);

      if (response) {
        setRelatorioEntregador(response);
      } else {
        setRelatorioEntregador([]);
      }
    } catch (err: any) {
      console.error('Erro ao buscar relatório de entregadores:', err);
      setError(err.response?.data?.message || 'Erro ao buscar relatório de entregadores');
      setRelatorioEntregador([]);
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setFormData({
      data: ''
    });
    setRelatorioEntregador([]);
    setError('');
  };

  return (
    <RelatoriosEntregadoresContent
      relatorioEntregador={relatorioEntregador}
      loading={loading}
      error={error}
      formData={formData}
      handleInputChange={handleInputChange}
      handleSearch={handleSearch}
      handleClear={handleClear}
    />
  );
};

export default RelatoriosEntregadoresContainer;
